import WordBin from "./WordBin";
import { useState, useEffect, useRef } from "react";
import "./Goals.css";
import Goal from "./Goal";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import { makeGetRequest } from "../../../../utils/api";
import { urls } from "../../../../utils/urls";

function Goals(props) {
  const [goals, setGoals] = useState([]);
  const [incorrectCount, setIncorrectCount] = useState(0);
  const [removeID, setRemoveID] = useState();
  const [wordBinArray, setWordBinArray] = useState([
    {
      id: 0,
      word: "",
    },
  ]);
  const goalRef = useRef([]);
  //settings start
  const [timer, setTimer] = useState();
  const [errorChecking, setErrorChecking] = useState();
  const [wordGroup, setWordGroup] = useState([]);
  const [goalGroup, setGoalGroup] = useState([]);
  const [allowImages, setAllowImages] = useState();

  const handleSettings = async () => {
    const response = await makeGetRequest(
      urls.activitiesUserSettings,
      "",
      true
    );
    const settings = response.data[0];
    setAllowImages(settings.allow_images);
    setTimer(settings.timer);
    setErrorChecking(settings.error_checking);
  };

  useEffect(() => {
    //handleSettings();
    wordData();
  }, []);
  //settings end

  useEffect(() => {
    if (removeID) {
      setWordBinArray(wordBinArray.filter((e) => e.id !== removeID));
    }
  }, [removeID]);

  useEffect(() => {
    if (wordBinArray.length === 0) {
      props.setGameComplete(true);
    }
  }, [wordBinArray]);

  const addWordToGroup = (id, goalID, goalRefID) => {
    if (id === goalID) {
      goalRef[goalRefID].style.backgroundColor = "green";
      setTimeout(() => {
        goalRef[goalRefID].style.backgroundColor = "white";
      }, 250);
      setTimeout(() => {
        goalRef[goalRefID].style.backgroundColor = "green";
      }, 500);
      setTimeout(() => {
        goalRef[goalRefID].style.backgroundColor = "white";
      }, 750);
      setTimeout(() => {
        goalRef[goalRefID].style.backgroundColor = "green";
      }, 1000);
      setRemoveID(id);
    } else {
      setTimeout(() => {
        goalRef[goalRefID].style.backgroundColor = "#ff4545";
      }, 250);
      setTimeout(() => {
        goalRef[goalRefID].style.backgroundColor = "white";
      }, 500);
      setTimeout(() => {
        goalRef[goalRefID].style.backgroundColor = "#ff4545";
      }, 750);
      setTimeout(() => {
        goalRef[goalRefID].style.backgroundColor = "white";
      }, 1000);
    }
  };

  const wordData = async () => {
    let wordsGroup = [];
    let goalsGroup = [];
    const response = await makeGetRequest(
      urls.category_sorts + "?active=True&image_game=True",
      "",
      true
    );
    const rnd = Math.floor(Math.random() * response.data.length);
    for (let i = 0; i < response.data[rnd].words.length; i++) {
      wordsGroup.push({
        id: response.data[rnd].words[i].id,
        word: response.data[rnd].words[i].word,
      });
      goalsGroup.push({
        id: response.data[rnd].words[i].id,
        image: response.data[rnd].words[i].image,
      });
    }
    setWordGroup(
      wordsGroup.sort((a, b) => {
        return 0.5 - Math.random();
      })
    );
    setGoalGroup(
      goalsGroup.sort((a, b) => {
        return 0.5 - Math.random();
      })
    );
  };

  useEffect(() => {
    setWordBinArray(wordGroup);
    setGoals(goalGroup);
  }, [wordGroup]);

  return (
    <div style={{ margin: "25px" }}>
      <Container>
        {props.timer ? (
          <Card bg="light" style={{ marginBottom: "10px" }}>
            <Card.Body>Current Time: {props.time}</Card.Body>
          </Card>
        ) : (
          ""
        )}
        <Row>
          {goals.map((g, x) => {
            return (
              <Goal
                id={g.id}
                image={g.image}
                dragType={"word"}
                goalRef={goalRef}
                goals={goals}
                addWordToGroup={addWordToGroup}
                key={x}
                x={x}
              />
            );
          })}
        </Row>
        <Row style={{ minHeight: "150px" }}>
          <WordBin words={wordBinArray} />
        </Row>
      </Container>
    </div>
  );
}

export default Goals;
